import React from 'react'
import { useState } from 'react';

const InputCheckBox = ({setData,dataId}) => {

    const [check, setCheck] = useState(false)
    const handleChange = ()=>{
      setCheck(!check)
      setData(dataId, check)
    }
 
  return (
    <div className="col col-lg form-check form-switch">
      <input
        type="checkbox"
        className="form-check-input"
        checked={check}
        onChange={handleChange}
      />
    </div>
  );
}

export default InputCheckBox